/* RESPONSIBLE TEAM: team-ml */
import type SdrFollowupEmail from 'embercom/models/operator/visual-builder/step/sdr-followup-email';
import StepConfig, { type StepConfigParams } from '../step';

export default class SdrFollowupEmailConfiguration extends StepConfig {
  declare step: SdrFollowupEmail;

  constructor(params: Omit<StepConfigParams, 'component'> & { component?: string }) {
    super({
      component: 'workflows/graph-editor/node-items/steps/sdr-followup-email',
      ...params,
    });
  }
}
